<template>

<div class="review" :class="{'has-response': review.response, 'is-business': viewAs === 'business', 'is-customer': viewAs === 'customer'}">

	<div class="review-head">

		<a v-if="viewAs === 'customer'" :href="review.business.url" class="review-head-avatar" :class="{'is-empty': !avatar}" :style="{backgroundImage: avatar}"></a>
		<div v-if="viewAs !== 'customer'" class="review-head-avatar" :class="{'is-empty': !avatar}" :style="{backgroundImage: avatar}"></div>

		<div class="review-head-about">

			<div class="review-head-about-name">{{ name }}</div>

			<div class="review-head-about-date">{{ text.read.created_prefix }} {{ review.date.written | formatDate('Do MMMM y') }}</div>

			<div class="review-head-about-rating">
				<div class="review-head-about-rating-item" v-for="score in maxScore" :key="score"><app-icon :name="(score <= review.score) ? 'scoreFull' : 'scoreEmpty'" /></div>
			</div>

		</div>

		<div class="review-head-actions" v-if="!window.is.mobile">

			<div v-if="!review.visible" class="review-head-actions-status is-pending" v-tooltip="text.read.pending_tooltip"><app-icon name="pending" /><span>{{ text.read.pending_label }}</span></div>

			<div v-if="viewAs !== 'customer' && !isSelf" class="review-head-actions-button is-report" v-tooltip="'Report this review'" v-on:click="onReportClick"><app-icon name="report" /></div>
			<app-share v-if="review.visible" class="review-head-actions-button" type="review" :identity="review.identity" />

		</div>

	</div>

	<div class="review-body">

		<div class="review-body-text" v-html="review.text"></div>

		<div class="review-body-facilities" v-if="facilities.length">

			<div class="review-body-facilities-item" v-for="(facility, index) in facilities" :key="index">

				<div class="review-body-facilities-item-name">{{ facility.name }}</div>

				<div class="review-body-facilities-item-rating">
					<div class="review-body-facilities-item-rating-item" v-for="score in maxScore" :key="score"><app-icon :name="(score <= facility.score) ? 'scoreFull' : 'scoreEmpty'" /></div>
				</div>

			</div>

		</div>

	</div>

	<div class="review-images" v-if="review.images.length">
		
		<div class="review-images-item" v-on:click="onPhotoClick(index)" v-tooltip="page.photos_tooltip" v-for="(photo, index) in review.images" :key="index" :style="{backgroundImage: $util.thumbnail(photo.image)}"></div>

	</div>

	<div class="review-details">
		
		<div class="review-details-items">

			<div class="review-details-item is-grow" v-if="review.recommended === 1"><small>{{ text.read.recommendation_title }}</small>{{ text.read.recommendation_yes }}</div>
			<div class="review-details-item is-grow" v-if="review.recommended === 2"><small>{{ text.read.recommendation_title }}</small>{{ text.read.recommendation_no }}</div>
			<div class="review-details-item" v-if="review.visit"><small>{{ text.read.date_title }}</small>{{ review.visit | formatDate('Do MMMM y') }}</div>
			<div class="review-details-item is-time" v-if="review.time"><small>{{ text.read.time_title }}</small>{{ review.time | formatDate('h:mma') }}</div>

			<template v-if="viewAs === 'business' && review.user.contact">
			<div class="review-details-item" v-if="session.business.premium">
				<small>{{ text.read.contact_title }}</small>
				<template v-if="review.user.contact.email"><a :href="linkContactEmail">{{ review.user.contact.email }}</a></template>
				<template v-if="review.user.contact.email && review.user.contact.phone"> & </template>
				<template v-if="review.user.contact.phone"><a :href="linkContactPhone">{{ review.user.contact.phone }}</a></template>
			</div>
			</template>
			
			<template v-if="viewAs === 'customer' && review.user.contact">
			<div class="review-details-item">
				<small>{{ text.read.contact_title }}</small>
				<template v-if="review.user.contact.email"><a :href="linkContactEmail">{{ review.user.contact.email }}</a></template>
				<template v-if="review.user.contact.email && review.user.contact.phone"> & </template>
				<template v-if="review.user.contact.phone"><a :href="linkContactPhone">{{ review.user.contact.phone }}</a></template>
			</div>
			</template>

		</div>

		<div class="review-details-prompt" v-if="!review.response && viewAs === 'business'">

			{{ text.read.respond_prompt }}

		</div>

	</div>

	<div class="review-response" v-if="review.response">

		<div class="review-response-text" v-html="review.response"></div>

	</div>

	<div class="review-buttons" v-if="viewAs === 'business'">

        <template v-if="window.is.mobile">

		<div v-if="!review.visible" class="review-head-actions-status is-pending" v-tooltip="text.read.pending_tooltip"><app-icon name="pending" /><span>{{ text.read.pending_label }}</span></div>
		<div v-if="viewAs !== 'customer' && !isSelf" class="review-head-actions-button is-report" v-tooltip="'Report this review'" v-on:click="onReportClick"><app-icon name="report" /></div>
		<app-share v-if="review.visible" class="review-head-actions-button" type="review" :identity="review.identity" />

        </template>

		<app-button theme="blue" v-if="!review.response && session.business.premium" :text="text.read.respond_button" v-on:click="onRespondClick" />

	</div>

	<div class="review-buttons" v-if="viewAs === 'customer'">

        <template v-if="window.is.mobile">

		<div v-if="!review.visible" class="review-head-actions-status is-pending" v-tooltip="text.read.pending_tooltip"><app-icon name="pending" /><span>{{ text.read.pending_label }}</span></div>
		<div v-if="viewAs !== 'customer' && !isSelf" class="review-head-actions-button is-report" v-tooltip="'Report this review'" v-on:click="onReportClick"><app-icon name="report" /></div>
		<app-share v-if="review.visible" class="review-head-actions-button" type="review" :identity="review.identity" />

        </template>

		<app-button theme="red" :text="text.read.delete_button" v-on:click="onDeleteClick" />

	</div>

	<div class="review-buttons" v-if="viewAs === 'public' && window.is.mobile">

		<div v-if="viewAs !== 'customer' && !isSelf" class="review-head-actions-button is-report" v-tooltip="'Report this review'" v-on:click="onReportClick"><app-icon name="report" /></div>
		<app-share v-if="review.visible" class="review-head-actions-button" type="review" :identity="review.identity" />

	</div>

</div>

</template>

<script>

export default {

	props: ['review', 'viewAs', 'text'],

	data: function() {

		return {
			maxScore: 5
		}

	},

	computed: {

		linkContactEmail: function() {

			return 'mailto:' + this.review.user.contact.email

		},

		linkContactPhone: function() {

			return 'tel:' + this.review.user.contact.phone

		},

        avatar: function() {

            var avatar = (this.viewAs === 'customer') ? this.review.business.avatar : this.review.user.avatar 

            return this.$util.thumbnail(avatar)

        },

        isSelf: function() {

            if (this.loggedin) {

                return this.session.id === this.review.user.id

            } 

            return false

        },

        facilities: function() {

            var facilities = []

            this.$_.each(this.data.facilities, function(name, key) {

                if (this.review.facilities[key]) {

                    facilities.push({
                        name: name,
                        score: this.review.facilities[key]
                    })

                }

            }.bind(this))

            return facilities

        },

		name: function() {

			return (this.viewAs === 'customer') ? this.review.business.name : this.review.user.name

		}

    },
    
    methods: {
        onPhotoClick: function(index) {

            this.$pubsub.$emit('photos.open', {
                photos: this.review.images,
                index: index
            })

        },

        onRespondClick: function() {

            this.$pubsub.$emit('modal.open', {
                name: 'review/respond',
                review: this.review,
                events: ['account/reviews/refresh']
            })

        },

        onDeleteClick: function() {

            this.$pubsub.$emit('modal.open', {
                name: 'review/delete',
                review: this.review,
                events: ['account/reviews/refresh']
            })

        },

        onReportClick: function() {

            this.$pubsub.$emit('modal.open', {
                name: 'review/report',
                review: this.review,
                text: this.text.report
            })

        }

    }

}

</script>

<style scoped>

.review {
	margin-bottom: 10px;
}

.review-head {
	display: flex;
	flex-direction: row;
	padding: 10px;
	border: 1px solid var(--color-grey-light);
	border-width: 1px 1px 0px 1px;
	border-radius: 4px 4px 0px 0px;
}

.is-desktop .review:hover .review-head {
	border-color: var(--color-grey-highlight);
}

.review-head-avatar {
	width: 64px;
	height: 64px;
	background-position: 50% 50%;
	background-size: cover;
	border-radius: 4px;
	display: block;
	background-color: #ddd;
	flex-shrink: 0;
}

.is-mobile .review-head-avatar {
    width: 40px;
    height: 40px;
}

.review-head-avatar.is-empty {
    background-image: url(~@/assets/avatar.png);
    background-color: var(--color-blue-light);
    background-size: 40px auto;
    background-repeat: no-repeat;
}

.review-head-about {
	display: flex;
	flex-basis: 0;
	flex-grow: 1;
	flex-direction: column;
	justify-content: center;
	padding: 0px 10px;
	height: 64px;
}

.review-head-about-name {
	font-size: 20px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	font-family: "grueber",serif;
	color: var(--color-grey-dark);
	margin-bottom: 2px;
}

.review-head-about-date {
	color: var(--color-grey-dark);
	font-size: 12px;
	margin-bottom: 4px;
}

.review-head-about-rating {
	display: flex;
	flex-direction: row;
	margin-left: -2px;
}

.review-head-about-rating-item {
	font-size: 20px;
	color: var(--color-yellow);
}

.review-head-actions {
	display: flex;
	flex-direction: row;
}

.review-head-actions-button {
	cursor: pointer;
	width: 40px;
	height: 40px;
	line-height: 40px;
	border-radius: 4px;
	text-align: center;
	font-size: 16px;
	transition: all 100ms linear;
	margin-left: 4px;
}

.review-head-actions-status {
	height: 40px;
	border-radius: 4px;
	font-weight: 700;
	line-height: 24px;
	padding: 0px 10px;
	display: flex;
	flex-direction: row;
	align-items: center;
}

.review-head-actions-status .icon {
	margin-right: 10px;
	font-size: 16px;
}

.review-head-actions-status.is-pending {
	background-color: var(--color-red-light);
	color: var(--color-red-dark);
}

.review-head-actions-button.is-report {
	color: var(--color-grey);
	line-height: 38px;
	background-color: var(--color-grey-light);
}

.is-desktop .review-head-actions-button.is-report:hover {
	color: #fff;
	background-color: var(--color-red-dark);
}

.review-head-actions-button.is-share {
	color: #fff;
	background-color: var(--color-blue-light);
}

.is-desktop .review-head-actions-button.is-share:hover {
	background-color: var(--color-blue-dark);
}

.review-images {
	border: 1px solid var(--color-grey-light);
	border-width: 1px 1px 0px 1px;
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	padding: 10px 10px 0px 10px;
	flex-wrap: wrap;
}

.is-desktop .review:hover .review-images {
	border-color: var(--color-grey-highlight);
}

.review-images-item {
	width: 64px;
	cursor: pointer;
	height: 64px;
	border-radius: 4px;
	background-position: 50% 50%;
	background-size: cover;
	margin: 0px 10px 10px 0px;
}

.review-body {
	border: 1px solid var(--color-grey-light);
	border-width: 0px 1px 0px 1px;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	padding: 10px 10px 20px 10px;
}

.is-mobile .review-body {
    flex-direction: column;
    padding-bottom: 10px;
}

.is-desktop .review:hover .review-body {
	border-color: var(--color-grey-highlight);
}

.review-body-text {
	font-size: 14px;
	line-height: 20px;
	font-weight: 300;
	color: var(--color-grey-dark);
	flex-grow: 1;
	flex-basis: 0;
}

.is-mobile .review-body-text {
    width: 100%;
}

.review-body-facilities {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
    width: 100%;
	flex-shrink: 0;
    margin-top: 20px;
}

.is-mobile .review-body-facilities {
    margin-top: 10px;
}

.review-body-facilities-item {
	width: 100px;
	display: flex;
	flex-direction: column;
	margin-bottom: 0px;
}

.is-mobile .review-body-facilities-item {
    width: 50%;
	margin-bottom: 5px;
}

.review-body-facilities-item:last-child {
	margin-bottom: 0px;
}

.review-body-facilities-item-name {
	font-weight: 300;
	font-size: 12px;
	display: block;
	margin-bottom: 2px;
	color: var(--color-grey-dark);
}

.review-body-facilities-item-rating {
	display: flex;
	flex-direction: row;
}

.review-body-facilities-item-rating-item {
	font-size: 16px;
	color: var(--color-blue-light);
}

.review-details {
	border: 1px solid var(--color-grey-light);
	padding: 20px 10px;
	border-radius: 0px 0px 4px 4px;
}

.review-details-items {
	display: flex;
	flex-direction: row;
}

.is-mobile .review-details-items {
    flex-direction: column;
}

.is-desktop .review:hover .review-details {
	border-color: var(--color-grey-highlight);
}

.review.is-customer .review-details,
.review.is-business .review-details {
    border-bottom-right-radius: 0px;
}

.review.has-response .review-details {
	border-bottom-width: 0px;
	border-radius: 0px;
}

.review-details-item {
	font-size: 14px;
	font-weight: 700;
	color: var(--color-grey-dark);
	margin-right: 40px;
	flex-shrink: 0;
	width: 150px
}

.review-details-item a {
	color: var(--color-blue-light);
	font-weight: 700;
}

.is-desktop .review-details-item a:hover {
	color: var(--color-blue-dark);
}

.is-mobile .review-details-item {
    width: 100%;
    margin-bottom: 10px;
    margin-right: 0px;
}

.review-details-item:last-child {
	margin-right: 0px;
}

.is-mobile .review-details-item:last-child {
    margin-bottom: 0px;
}

.review-details-item.is-time {
	width: 75px
}

.review-details-item.is-grow {
	flex-grow: 1;
	flex-basis: 0;
}

.review-details-item small {
	font-weight: 300;
	font-size: 12px;
	display: block;
	margin-bottom: 2px;
}

.review-details-prompt {
	margin-top: 20px;
	font-size: 12px;
	line-height: 14px;
	font-weight: 300;
	color: var(--color-grey-dark);
}

.review-response {
	background-color: var(--color-blue-light);
	padding: 10px;
	border-radius: 0px 0px 4px 4px;
}

.review.is-customer .review-response {
    border-bottom-right-radius: 0px;
}

.review-response:before {
	content: ' ';
	position: absolute;
	border-style: solid;
	left: 20px;
	top: -8px;
    border-width: 0 10px 8px 10px;
    border-color: transparent transparent var(--color-blue-light) transparent;
}

.review-response-text {
	font-size: 14px;
	line-height: 20px;
	font-weight: 400;
	color: #fff;
}

.review-buttons {
    display: flex;
    flex-direction: rpw;
    justify-content: flex-end;
    margin-top: -1px;
}

.is-mobile .review-buttons {
    margin-top: 4px;
}

.review-buttons >>> .button {
    border-radius: 0px 0px 4px 4px;
    margin-left: 4px;
}

</style>